import { render } from "./Carrusel-Component-2_ingles.vue?vue&type=template&id=28977851&scoped=true"
import script from "./Carrusel-Component-2_ingles.vue?vue&type=script&lang=js"
export * from "./Carrusel-Component-2_ingles.vue?vue&type=script&lang=js"

import "./Carrusel-Component-2_ingles.vue?vue&type=style&index=0&id=28977851&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28977851"]])

export default __exports__